module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00218.8cc1a15a.jpg";